const state = {
  submitting: false,
  submitted: false,
}

const getters = {}

const mutations = {
  SET_STATUS: (state, statusData = {}) => {
    const newData = { ...state, ...statusData }

    state.submitting = newData.submitting
    state.submitted = newData.submitted
  },
}

const actions = {
  setStatus({ commit }, statusData) {
    commit('SET_STATUS', statusData)
  },
}

export default { namespaced: true, state, getters, mutations, actions }
